export const AgendaScenarioId = 'TimePanelAgenda';
